/**
 * The fixed pixel height of the navigation bar. Exported so consumers (e.g.
 * the hero stage) can size themselves to fill the remaining viewport without
 * duplicating this magic number.
 */
export const NAV_BAR_HEIGHT_PX = 88;

export const UNAUTHENTICATED_FEEDBACK_FORM_URL =
	'https://customerfeedback.atlassian.net/servicedesk/customer/portal/5186';
